






















import { Vue, Component } from "vue-property-decorator";
import Swiper, { SwiperOptions } from "swiper";
import apiStorageInterface from "@/services/apiStorageInterface";
import { Getter, Mutation } from "vuex-class";
import { OverlayGetter, OverlayMutation } from "@/components/overlay/types";
import { Namespace } from "@/store/types";

@Component({})
export default class Subtitles extends Vue {
  @Mutation(OverlayMutation.SetActiveTranslation, {
    namespace: Namespace.Overlay
  })
  setActiveTranslation!: (langCode: string | null) => void;

  @Getter(OverlayGetter.GetActiveTranslation, {
    namespace: Namespace.Overlay
  })
  getActiveTranslation!: string | null;

  @Getter(OverlayGetter.GetActiveTranslationId, {
    namespace: Namespace.Overlay
  })
  getActiveTranslationId!: number | null;

  subtitles: TextTrackList | never[] = [];
  subSwiper: Swiper | undefined;
  playerElem: HTMLVideoElement | null =
    document.querySelector("div#player video");
  activeTranslation = 0;

  swiperOptions: SwiperOptions = {
    slidesPerView: 5,
    spaceBetween: 40,
    breakpoints: {
      // when window width is <= 768px
      768: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    keyboard: {
      enabled: false
    }
  };
  mounted(): void {
    let vodSubtitles = document.querySelector("div#player video")
      ? (document.querySelector("div#player video") as HTMLVideoElement)
          .textTracks
      : [];

    if (vodSubtitles.length > 0) this.subtitles = vodSubtitles;

    this.$nextTick(async (): Promise<void> => {
      this.subSwiper = new Swiper(".subtitle-swiper", this.swiperOptions);

      this.subSwiper.on("click", (swiper: Swiper) => {
        if (this.playerElem !== null) {
          this.resetSubtitleStatus();
          this.playerElem.textTracks[swiper.clickedIndex].mode = "showing";
          this.activeTranslation = swiper.clickedIndex;
          this.setActiveTranslation(
            this.playerElem.textTracks[swiper.clickedIndex].language
          );
          swiper.slideTo(this.activeTranslation);
        }
      });

      //if there is already a subtitle selected no need to try to check for app default lang
      const subtitlePresent = this.focusActiveSubtitle();
      if (!subtitlePresent) await this.focusAppLangSubtitle();
      this.subSwiper.slideTo(this.activeTranslation);
    });
  }

  //focusing on already selected subtitle language
  focusActiveSubtitle(): boolean {
    if (this.playerElem?.textTracks && this.playerElem?.textTracks.length > 0) {
      for (const key in this.playerElem.textTracks) {
        const value = this.playerElem.textTracks[key];
        if (
          this.getActiveTranslation === value.language ||
          this.getActiveTranslationId === +key
        ) {
          this.activeTranslation = +key;
          return true;
        }
      }
      this.activeTranslation = 0;
      this.playerElem.textTracks[this.activeTranslation].mode = "showing";
      return true;
    }

    return false;
  }

  //setting subtitle lang to be user app lang if possible
  async focusAppLangSubtitle(): Promise<void> {
    let userInfo = await apiStorageInterface.fetchUserInfo();

    if (this.playerElem?.textTracks && this.playerElem?.textTracks.length > 0) {
      for (const key in this.playerElem.textTracks) {
        const value = this.playerElem.textTracks[key];
        if (value && value.language === userInfo.defaultUserLanguage?.code) {
          this.activeTranslation = +key;
          this.playerElem.textTracks[+key].mode = "showing";
          this.setActiveTranslation(this.playerElem.textTracks[+key].language);
        }
      }
    }
  }

  resetSubtitleStatus(): void {
    if (this.playerElem?.textTracks && this.playerElem?.textTracks.length > 0) {
      for (let track of this.playerElem.textTracks) {
        track.mode = "hidden";
      }
    }
  }
}
